import { Button } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "Common/ReactIcons";
import utils from "utils";
import { CONSTANTS } from "utils/constant";
import Icons from "Common/Icons";
export default class extends React.Component {
    _baseClassName = "schedule-appointment-container";
    constructor(props) {
        super(props);

        this.state = {
            is_evaluated: this.props.is_evaluated,
            show: this.props.show,
            membership_type: this.props.membership_type,
        }
    }

    render() {
        return (
            <div className={this._baseClassName}>
                <div className="main-content">
                    <div className="phi-not-filled-content">
                        <div><img className="center-img" src={Icons.warning_orange}/></div>
                        <div className="center-text">{!this.state.show ? this.state.membership_type ? ` ${CONSTANTS.YOUR} ${this.state.membership_type} ${CONSTANTS.NOT_SUBSCRIBED_CENTER_TEXT_1}` : `${CONSTANTS.NOT_SUBSCRIBED_CENTER_TEXT_2}` : `${CONSTANTS.NOT_SUBSCRIBED_CENTER_TEXT_3}`} </div>
                        <div>
                            {!this.state.show ? <Link to="/logged-in-user/subscription-plan">
                                <Button className="eval-btn" icon={<ArrowRight />}> &nbsp; {this.state?.is_evaluated ? `${CONSTANTS.TAKE_SUBSCRIPTION_PLAN}` :  `${CONSTANTS.TAKE_SUBSCRIPTION_PLAN}`}</Button>
                            </Link> :
                            <Link to="/logged-in-user/consultation-history">
                                <Button className="eval-btn" icon={<ArrowRight />}>{CONSTANTS.GO_TO_APPOINTMENTS}</Button>
                            </Link>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}